import React, { useEffect, useRef, useState, useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../comman/Sidebar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";

import {
  Button,
  Checkbox,
  Grid,
  Icon,
  InputAdornment,
  ListItemText,
  PaginationItem,
  Stack,
  TableSortLabel,
  TextField,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { authHeader } from "../comman/MainFunction";
import {
  CustomMessage,
  deCryptFun,
  enCryptFun,
} from "../comman/CustomFunction";
import API from "../comman/API";
import moment from "moment";
import {
  GET_ALL_CUSTOMERS_URL,
  GET_CUSTOMER_ALL_LOG_FILTER_URL,
  GET_TYPES_FILTER_URL,
  USERLOG_LIST_URL,
} from "../../constants/ApiRoute";
import { debounce, filter } from "underscore";
import CustomerFilter from "../model/CustomerFilter";

import { useDispatch, useSelector } from "react-redux";
import { getAllTypeList, getAlluserList } from "../../redux/action";
import Pagination from "@mui/material/Pagination";
import CustomPageLoading from "../comman/CustomPageLoading";
import UserClearFilter from "../model/UserClearFilter";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { CUSTOMERS_ROUTE, USERS_ROUTE } from "../../constants/RoutePath";
import { useToast } from "../comman/CustomMessages";
import customerNodata from "../../images/billing-nodata.svg";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import UnfoldMoreSharpIcon from "@mui/icons-material/UnfoldMoreSharp";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import Navbar from "../comman/Navbar";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import NoRecordFound from "../comman/NoRecordFound";
import UserLogFilter from "./UserLogFilter";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, search, theme) {
  return {
    fontWeight:
      search.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
const filterInitial = {
  userId: [],
  logTypeId: [],
  dateRange: 0,
};
const CustomerHistory = () => {
  const theme = useTheme();
  const showToast = useToast();
  const [search, setSearch] = React.useState([]);
  const [customers, setCustomers] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [clearFiltervalue, setClearFilterValue] = useState(false);
  const [typeList, setTypeList] = useState([]);
  const [filterValue, setFilterValue] = useState(filterInitial);
  const [clearFlag, setClearFlag] = useState(false);
  const [page, setPage] = useState(0);
  const [pageChangeValue, setPageChangeValue] = useState(true);
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState(10);
  const [loading, setLoading] = useState(false);
  const [appliedFiler, setAppliedFilter] = useState(false);
  const dispatch = useDispatch();
  const userListSel = deCryptFun(useSelector((s) => s.AllUserReducer));
  let usersListFind = userListSel && JSON.parse(userListSel).data;
  const navigation = useNavigate();
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [selectedcustomers, setSelectedCustomers] = useState([]);
  const [sortClickedTime, setSortClickedTime] = useState("");
  console.log(selectedcustomers, "selectedCustomersrsrssr", customerList);
  console.log(filterValue, "filterValue");
  console.log(filterInitial, "filterInitialfilterInitial");
  const [searchInput, setSearchInput] = useState("");
  const filterClose = () => {
    setOpenFilter(false);
  };

  const canceFilter = () => {
    // if (!appliedFiler) {
    //   setFilterValue({ ...filterValue, userId: [], logTypeId: [] });
    // }
    setOpenFilter(false);
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPage(0);
    let f;
    let name = [];
    f = JSON.parse(userListSel).data.filter(
      (r) => parseInt(r.UserId) == parseInt(value)
    );
    console.log("f,", f);

    if (f.length > 0) {
      name = f && f[0].UserName;
    }
    setSearch(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  // const handleSortRequest = (property) => {
  //   const isAsc = orderBy === property && order === "asc";

  //   // console.log("ASC -->", isAsc);
  //   // console.log("order", order);
  //   // console.log("orderBy", orderBy);

  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);

  //   if (order === "desc") {
  //     setOrder("");
  //     setOrderBy("");
  //   }
  // };

  const handleSortRequest = (property) => {
    if (
      (customerList &&
        customerList.length > 0 &&
        filterValue?.logTypeId?.length > 0) ||
      filterValue?.userId?.length > 0 ||
      filterValue?.dateRange
    ) {
      const isAsc = orderBy === property && order === "asc";
      // console.log("Sort ==> ASC -->", isAsc);
      // console.log("Sort ==> order", order);
      // console.log("Sort ==> orderBy", orderBy);
      // console.log("Sort ==> property", property);
      // console.log("Sort ==> +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");

      let orderValue = isAsc ? "desc" : "asc";
      setOrder(orderValue);
      setOrderBy(property);

      if (order === "desc") {
        setOrder("");
        setOrderBy("");
      }

      if (orderBy != property) {
        setOrder("asc");
        setOrderBy(property);
      }
      setPage(0);
      setSortClickedTime(new Date().toLocaleString());
    }
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  // const sortedList = useMemo(() => {
  //   if (orderBy) {
  //     return [...customerList].sort((a, b) => {
  //       if (orderBy === "LogDateTime") {
  //         const dateA = new Date(a[orderBy]).getTime();
  //         const dateB = new Date(b[orderBy]).getTime();

  //         if (order === "asc") {
  //           return dateA - dateB;
  //         } else {
  //           return dateB - dateA;
  //         }
  //       } else {
  //         const valueA = a[orderBy].toLowerCase();
  //         const valueB = b[orderBy].toLowerCase();

  //         if (order === "asc") {
  //           return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
  //         } else {
  //           return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
  //         }
  //       }
  //     });
  //   }
  //   return customerList;
  // }, [customerList, orderBy, order]);

  // useEffect(() => {
  //   if (clearFiltervalue == true) {
  //     setFilterValue(filterInitial);
  //   }
  // }, [clearFiltervalue]);
  // const getAllCustomer = async () => {
  //   const config = {
  //     method: "GET",
  //     url: GET_ALL_CUSTOMERS_URL,
  //     headers: authHeader(),
  //   };

  //   try {
  //     const response = await API(config);
  //     console.log("log api", response);
  //     let decryptedResponse = deCryptFun(response.data);
  //     const parsedResponse = JSON.parse(decryptedResponse);
  //     if (parsedResponse.status == "Success") {
  //       setCustomers(parsedResponse.data);
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       let { data } = error.response;
  //       let p = deCryptFun(data);
  //       let v = JSON.parse(p);
  //             showToast(v.message, "error");

  //     }
  //   }
  // };

  // const delaySearch = useRef(
  //   debounce((search, page, clearFiltervalue) =>
  //     getLogDetails(search, page, clearFiltervalue)
  //   )
  // ).current;

  useEffect(() => {
    console.log(search, page, clearFiltervalue);
    if (pageChangeValue) {
      getLogDetails(search, page, clearFiltervalue);
      // delaySearch(search, page, clearFiltervalue);
    }
  }, [search, page, clearFiltervalue, pageChangeValue]);

  useEffect(() => {
    dispatch(getAlluserList());
    dispatch(getAllTypeList());
  }, []);

  useEffect(() => {
    if (appliedFiler || selectedcustomers.length > 0) {
      const idsString = selectedcustomers.map((item) => item.UserId).join(",");
      getLogDetails(idsString, 0, filterValue.logTypeId);
    }
  }, [selectedcustomers, appliedFiler, filterValue.logTypeId]);

  useEffect(() => {
    if (sortClickedTime) {
      getLogDetails();
    }
  }, [sortClickedTime]);

  const filterOpenFun = () => {
    // setSearch([]);
    setOpenFilter(!openFilter);
  };

  const clearFilterOpen = () => {
    const clearedFilter = {
      userId: [],
      logTypeId: [],
      dateRange: 0,
    };
  
    setFilterValue(clearedFilter); // Reset `filterValue`
    filterInitial.userId = [];
    filterInitial.logTypeId = [];
    filterInitial.dateRange = 0; // Update `filterInitial` explicitly
    setAppliedFilter(false);
    setClearFilterValue("");
    setSelectedCustomers([]);
    setSearchInput("")
    if (selectedcustomers && selectedcustomers.length > 0) {
      const idsString = selectedcustomers.map((item) => item.UserId).join(",");
      getLogDetails(idsString);
    }
  };
  
  const resetFilter = (value) => {
    setClearFlag(!clearFlag);
    setClearFilterValue(value);

    if (value) {
      setClearFilterValue(value);
      setFilterValue({
        userId: [],
        logTypeId: [],
        dateRange: 0,
      });
      setAppliedFilter(false);
    }
  };

  const applyFilterFun = (userId, logTypeId) => {
    setSelectedCustomers((prevSelectedCustomers) => {
      const filteredValue = usersListFind.filter((item) =>
        userId.includes(item.UserId)
      );
      return filteredValue;
    });

    setFilterValue((prevFilterValue) => ({
      ...prevFilterValue,
      userId: userId,
      logTypeId: logTypeId,
    }));

    setPageChangeValue(false);
    setPage(0);
    setAppliedFilter(true);
    setSearch(userId.length !== 0 ? userId : []);
    setOpenFilter(false);
  };

  const handlePageChange = (e, value) => {
    setPageChangeValue(true);
    setPage(value - 1);
  };

  const BackFun = () => {
    navigation(CUSTOMERS_ROUTE);
  };

  const clearProject = () => {
    setSearch([]);
    setPage(0);
    setFilterValue(filterInitial);
  };
  const selectedCustomersRef = useRef(selectedcustomers);

  const handleSearchDeleteOnChange = (value) => {
    var arr = selectedcustomers.filter((item) => item.UserId !== value);
    var uniqueSelectedProjects = arr;
    setSelectedCustomers(arr);
    const arrayvalues = arr.map((valu) => valu.UserId);
    setFilterValue((val) => ({
      ...val,
      userId: arrayvalues,
    }));
    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      const idsString = uniqueSelectedProjects
        .map((item) => item.UserId)
        .join(",");
      getLogDetails(idsString);
    } else {
      getLogDetails();
    }
    setPage(0);
  };

  // const handleSearchDeleteOnChange = (value) => {
  //   var arr = selectedcustomers.filter((item) => item.UserId !== value);
  //   var uniqueSelectedProjects = arr;
  //   setSelectedCustomers(arr);
  //   console.log(arr, "arssssssssss");
  //   const arrayvalues = arr.map((valu) => valu.UserId);
  //   setFilterValue((val) => ({
  //     ...val,
  //     userId: arrayvalues,
  //   }));

  //   if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
  //     const idsString = uniqueSelectedProjects
  //       .map((item) => item.UserId)
  //       .join(",");
  //     getLogDetails(idsString);
  //   } else {
  //     getLogDetails();
  //   }
  //   setPage(0);
  // };

  const findDuplicateProjectId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.UserId)) {
        duplicates.add(obj.UserId);
      } else {
        seen.add(obj.UserId);
      }
    });

    return Array.from(duplicates);
  };

  const findDuplicateUserId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.UserId)) {
        duplicates.add(obj.UserId);
      } else {
        seen.add(obj.UserId);
      }
    });

    return Array.from(duplicates);
  };

  // const handleSearchOnChangeOLD = (event, newValue) => {
  //   const uniqueSelectedProjects = newValue.filter(
  //     (item, index, self) =>
  //       index === self.findIndex((t) => t.UserId === item.UserId)
  //   );
  //   setSelectedCustomers(uniqueSelectedProjects);

  //   const idsString = uniqueSelectedProjects
  //     .map((item) => item.UserId)
  //     .join(",");

  //   getLogDetails(idsString, 0);
  //   // setPage(0)
  // };

  const handleSearchOnChangeOLD = (event, newValue) => {
    if (event.target.type != "text") {
      // Remove duplicates from newValue
      const uniqueSelectedProjects = newValue.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.UserId === item.UserId)
      );

      // Map to get only UserIds
      const mappingValues = uniqueSelectedProjects.map((user) => user.UserId);

      // Set the filterValue state with the userId array
      setFilterValue((prevValue) => ({
        ...prevValue,
        userId: mappingValues,
      }));

      // Update the selected customers state
      setSelectedCustomers(uniqueSelectedProjects);

      if (uniqueSelectedProjects.length > 0) {
        const idsString = mappingValues.join(",");
        setSearch(idsString);
        setPage(0);
        getLogDetails(idsString, 0);
      } else {
        setSearch("");
        setPage(0);
        // Optionally call getLogDetails without IDs
      }
    }
  };

  const handleSearchOnChange = (event, newValue) => {
    setSearchInput((prev) => prev);
    if (event.target.type != "text") {
      const duplicateArray = findDuplicateUserId(newValue);
      if (duplicateArray && duplicateArray.length > 0) {
        const updatedNewArray = newValue.filter(
          (obj) => obj.UserId !== duplicateArray[0]
        );
        newValue = updatedNewArray;
      }

      const uniqueSelectedProjects = newValue.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.UserId === item.UserId)
      );

      // Update the selected customers state
      setSelectedCustomers(uniqueSelectedProjects);

      if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
        const idsString = uniqueSelectedProjects
          .map((item) => item.UserId)
          .join(",");
        setSearch(idsString);
        setFilterValue((prevValue) => ({
          ...prevValue,
          userId: idsString,
        }));
        setPage(0);
        //filterUserSubmit(idsString, "");
      } else {
        setSearch("");
        setFilterValue((prevValue) => ({
          ...prevValue,
          userId: "",
        }));
        setPage(0);
        //filterUserSubmit();
      }
      // setTimeout(setAttributeForTitle, 2000);
    }
    setSearchInput((prev) => prev); 
  };

  const handleSearchCheckboxOnChange = (value, isSelected) => {
    let updatedProjects;

    if (isSelected) {
      // Remove the selected item from the array
      updatedProjects = selectedcustomers.filter(
        (item) => item.UserId !== value.UserId
      );
    } else {
      // Add the selected item to the array
      updatedProjects = [...selectedcustomers, value];
    }

    // Map to get only UserIds
    const mappingValues = updatedProjects.map((user) => user.UserId);

    // Set the filterValue state with the updated userId array
    setFilterValue((prevValue) => ({
      ...prevValue,
      userId: mappingValues,
    }));

    // Update the selected customers state
    setSelectedCustomers(updatedProjects);

    if (updatedProjects.length > 0) {
      const idsString = mappingValues.join(",");
      // Optionally call getLogDetails with the updated IDs
      // getLogDetails(idsString);
    } else {
      // Optionally call getLogDetails without IDs
      // getLogDetails();
    }
    setSearchInput((prev) => prev); 
    setPage(0); // Reset the page to 0
  };

  // useEffect(() => {
  //   getLogDetails();
  // }, [order]);

  const getLogDetails = async (search, pageVal, typeId) => {
    setLoading(true);

    // Determine if search is a string or array and split accordingly
    // const searchArray = Array.isArray(search)
    //   ? search
    //   : typeof search === "string" && search.length > 1
    //   ? search.split(",")
    //   : [];

    // Combine userId from search and filter, ensuring unique values
    const combinedUserId = [filterValue.userId || []].filter(
      (v, i, a) => a.indexOf(v) === i
    ); // Ensure unique values
    const { logTypeId, dateRange } = filterValue;
    console.log(logTypeId, "filetrrrrrrrrrrrrrrr");

    let data = {
      count: count,
      offset: page,
      sort: "",
      orderBy: "",
      userId:
        // combinedUserId.length == 1 && searchArray?.length === 1
        //   ? searchArray[0]
        // : combinedUserId.length > 0 && searchArray?.length == 0
        combinedUserId.length > 0
          ? combinedUserId.join(",")
          : searchArray.join(","),
      logTypeId: logTypeId && logTypeId.length > 0 ? logTypeId.join(",") : "",
      dateRange: dateRange,
    };

    if (typeof pageVal === "number") {
      data.offset = pageVal;
    }

    if (order && orderBy == "LogDateTime") {
      data.sort = order == "asc" ? "desc" : "asc";
    }

    if (order && orderBy != "LogDateTime") {
      data.sort = order;
    }

    if (orderBy) {
      data.orderBy = orderBy;
    }

    console.log("data option -->", data);
    console.log("data option order -->", order);
    console.log("data option orderBy -->", orderBy);
    console.log("data data Sorting Api -->", data);

    if (data.dateRange == 0 && data.logTypeId == "" && data.userId == "") {
      setOrder("");
      setOrderBy("");
    }

    const config = {
      method: "GET",
      url: GET_CUSTOMER_ALL_LOG_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        console.log("data==>", parsedResponse);
        setCustomerList(parsedResponse.data);
        setTotal(Math.ceil(parsedResponse.totalCount / count));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    const handlePopState = () => {
      localStorage.setItem("USER_PAGE_BACKBUTTON_CLICK", true);
      navigation(USERS_ROUTE);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"6"} />

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar
            title={"Users History"}
            backFlag={true}
            backRoute={USERS_ROUTE}
          />
          <Box className="bg-box user-log">
            <Grid container>
              <Grid xs={12} md={8}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  options={usersListFind}
                  disableCloseOnSelect
                  limitTags={1}
                  getOptionLabel={(option) =>
                    option.FirstName.concat(" ").concat(option.LastName)
                  }
                  filterOptions={(options, { inputValue }) => {
                    if (inputValue.trim() === "") {
                      // Sort all options when there's no input value
                      return options.sort((a, b) =>
                        `${a.FirstName} ${a.LastName}`.localeCompare(
                          `${b.FirstName} ${b.LastName}`
                        )
                      );
                    }
                    // Filter and sort matching options
                    return options
                      .filter((option) =>
                        `${option.FirstName} ${option.LastName}`
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      )
                      .sort((a, b) =>
                        `${a.FirstName} ${a.LastName}`.localeCompare(
                          `${b.FirstName} ${b.LastName}`
                        )
                      );
                  }}
                  onChange={handleSearchOnChange}
                  value={selectedcustomers}
                  inputValue={searchInput} // Preserve search input
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason !== "reset") {
                      setSearchInput(newInputValue); // Prevent clearing when clicking outside
                    }
                  }}
                  renderTags={() => null}
                  renderOption={(props, option, { selected }) => {
                    const isSelected = selectedcustomers.some(
                      (project) => project.UserId === option.UserId
                    );

                    return (
                      <li {...props} key={option.UserId}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={isSelected}
                          onChange={() =>
                            handleSearchCheckboxOnChange(option, isSelected)
                          }
                        />
                        <span className="select-option-text">{`${option.FirstName} ${option.LastName}`}</span>
                      </li>
                    );
                  }}
                  sx={{
                    width: { xs: "100%", md: 300 },
                    minWidth: { xs: "230px", md: "auto" },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Search Users"
                    />
                  )}
                />

                <div style={{ marginTop: 5 }}>
                  {selectedcustomers.map((option) => (
                    <Chip
                      key={option.UserId}
                      label={`${option.FirstName} ${option.LastName}`}
                      onDelete={() => {
                        handleSearchDeleteOnChange(option.UserId);
                      }}
                      style={{ margin: 5 }}
                    />
                  ))}
                </div>
              </Grid>
              <Grid sx={{ float: "right", textAlign: "right" }} xs={12} md={4}>
                {console.log('userid count',filterValue.userId.length,filterInitial.userId.length)}
                {(appliedFiler &&
                (((filterValue.userId.length !== filterInitial.userId.length)&&(filterValue.userId.length>0)) ||
                 ( (filterValue.logTypeId.length !==
                    filterInitial.logTypeId.length)&&(filterValue.logTypeId.length>0) )||
                  filterValue.dateRange !== filterInitial.dateRange)||
                  selectedcustomers?.length > 0) ? (
                  <Button
                    startIcon={
                      <span class="material-symbols-outlined">close</span>
                    }
                    className="clear-btn"
                    sx={{ mr: "10px" }}
                    variant="outlined"
                    color="error"
                    onClick={clearFilterOpen}
                  >
                    {" "}
                    Clear Filter{" "}
                  </Button>
                ) : (
                  // </Stack>
                  <></>
                )}
                <Stack
                  className="filter"
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  onClick={filterOpenFun}
                >
                  <span class="material-symbols-outlined">filter_list</span>
                  <Typography> Filter</Typography>
                </Stack>
              </Grid>
            </Grid>
            <Grid sx={{ mt: 2 }} container>
              <Grid xs={12} md={12}>
                <TableContainer
                  sx={{
                    boxShadow: "none",
                    maxHeight: { xs: 440, md: 440, lg: 400, xl: 527 },
                  }}
                  component={Paper}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ minWidth: { xs: "100px", md: "200px" } }}
                        >
                          <TableSortLabel
                            active={orderBy === "LogDateTime"}
                            direction={
                              orderBy === "LogDateTime" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("LogDateTime")}
                            IconComponent={() => getSortIcon("LogDateTime")}
                            style={
                              orderBy === "LogDateTime"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Log Date
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          sx={{ minWidth: { xs: "auto", md: "310px" } }}
                        >
                          <TableSortLabel
                            active={orderBy === "UserName"}
                            direction={orderBy === "UserName" ? order : "asc"}
                            onClick={() => handleSortRequest("UserName")}
                            IconComponent={() => getSortIcon("UserName")}
                            style={
                              orderBy === "UserName" ? { color: "#007fff" } : {}
                            }
                          >
                            User
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "Description"}
                            direction={
                              orderBy === "Description" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("Description")}
                            IconComponent={() => getSortIcon("Description")}
                            style={
                              orderBy === "Description"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Description
                          </TableSortLabel>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {(customerList &&
                      customerList.length > 0 &&
                      filterValue?.logTypeId?.length > 0) ||
                    filterValue?.userId?.length > 0 ||
                    filterValue?.dateRange ? (
                      <TableBody>
                        {loading && <CustomPageLoading />}
                        {customerList &&
                          customerList.map((rec, i) => {
                            // var dataMoment = rec.LogDateTime
                            //   ? moment(rec.LogDateTime).format(
                            //       "MMMM Do YYYY, h:mm A"
                            //     )
                            //   : "";

                            const dataMoment = rec.LogDateTime
                              ? moment
                                  .utc(rec.LogDateTime)
                                  .format("MMMM Do YYYY, h:mm A")
                              : "";

                            return (
                              <TableRow key={`customer_${i}`}>
                                <TableCell scope="row">{dataMoment}</TableCell>
                                <TableCell>{rec.Email}</TableCell>
                                <TableCell sx={{ lineBreak: "anywhere" }}>
                                  {rec.Description}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    ) : (
                      <></>
                    )}
                  </Table>
                  {filterValue.userId.length == 0 &&
                  filterValue.logTypeId.length == 0 &&
                  filterValue.dateRange == 0 &&
                  selectedcustomers?.length == 0 ? (
                    <Box
                      sx={{
                        textAlign: "center",
                        width: "100%",
                        background: "#fff",
                        marginTop: "25px",
                        borderRadius: "5px",
                      }}
                    >
                      <img
                        style={{ maxWidth: "326px", width: "100%" }}
                        src={customerNodata}
                      />

                      <Typography
                        className="no-data-text"
                        style={{ marginTop: "25px" }}
                      >
                        Please select the users from the dropdown above.
                      </Typography>
                    </Box>
                  ) : (
                    <></>
                  )}
                  <></>
                </TableContainer>
                {/* {(!loading &&
                  selectedcustomers &&
                  selectedcustomers?.length > 0) ||
                // (sortedList && sortedList?.length > 0)) ||
                (customerList && customerList?.length > 0) ||
                (appliedFiler &&
                  (filterValue.userId.length !== filterInitial.userId.length ||
                    filterValue.logTypeId.length !==
                      filterInitial.logTypeId.length ||
                    filterValue.dateRange !== filterInitial.dateRange)) ? (
                  <Pagination
                    sx={{ mt: "15px", float: "right" }}
                    shape="rounded"
                    // hidePrevButton
                    // hideNextButton
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          previous: () => (
                            <Icon className="material-symbols-outlined">
                              keyboard_backspace
                            </Icon>
                          ),
                          next: () => (
                            <Icon className="material-symbols-outlined">
                              east
                            </Icon>
                          ),
                        }}
                        {...item}
                      />
                    )}
                    count={total}
                    page={page + 1}
                    onChange={handlePageChange}
                  />
                ) : (
                  <></>
                )} */}

                {!loading &&
                (filterValue.userId.length !== filterInitial.userId.length ||
                  filterValue.logTypeId.length !==
                    filterInitial.logTypeId.length ||
                  filterValue.dateRange !== filterInitial.dateRange) &&
                customerList &&
                customerList.length === 0 ? (
                  <NoRecordFound />
                ) : filterValue?.logTypeId?.length > 0 ||
                  filterValue?.userId?.length > 0 ||
                  filterValue?.dateRange ? (
                  <Pagination
                    sx={{ mt: "15px", float: "right" }}
                    shape="rounded"
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          previous: () => (
                            <Icon className="material-symbols-outlined">
                              keyboard_backspace
                            </Icon>
                          ),
                          next: () => (
                            <Icon className="material-symbols-outlined">
                              east
                            </Icon>
                          ),
                        }}
                        {...item}
                      />
                    )}
                    count={total}
                    page={page + 1}
                    onChange={handlePageChange}
                  />
                ) : null}
              </Grid>
              {openFilter && (
                <UserLogFilter
                  open={openFilter}
                  handleClose={filterClose}
                  handleCancel={canceFilter}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                  filterInitial={filterInitial}
                  applyFilterFun={applyFilterFun}
                  getLogDetails={getLogDetails}
                  showCustomer={"no"}
                  setSelectedCustomers={setSelectedCustomers}
                  selectedcustomers={selectedcustomers}
                />
              )}
              {clearFlag && (
                <UserClearFilter
                  open={clearFlag}
                  clearFiltervalue={clearFiltervalue}
                  setClearFilterValue={setClearFilterValue}
                  resetFilter={resetFilter}
                />
              )}
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CustomerHistory;
